import { PASSENGER_TRAIN } from '@/utils/constants';

type JourneyDisplayParams = {
  journeyCategory?: string;
  lineNumber?: string;
  journeyType?: string | null;
};

export const getJourneyDisplayName = ({
  journeyCategory,
  lineNumber = '',
  journeyType,
}: JourneyDisplayParams): string => {
  if (journeyCategory === PASSENGER_TRAIN) {
    return lineNumber;
  }

  return journeyType ?? lineNumber;
};
